<template>
    <div class="pay_info">
        <div v-wechat-title="$route.meta.title"></div>
        <Topbar></Topbar>
        <!-- 充值信息 -->
        <div style="display: flex; flex-direction: column; align-items: center; margin-top: 0px;">
            <div style="padding: 10px; height: 60px; width: 85%; background-color: #FFFFFF; display: flex; align-items: center; justify-content: space-between;">
                <div style="display: flex; width: 150px; align-items: center; justify-content: space-between;">
                    <span :class="{blue_text:planShow}">充值信息</span>
                    <span style="font-size: 13px;" class="icon iconfont icon-z043"></span>
                    <span :class="{blue_text:!planShow}">打款</span>
                </div>
                <div v-show="planShow" style="display: flex;align-items: center; width: 150px; justify-content: space-between;">
                    <span>取消</span>
                    <Button type="primary" @click="nextClick">下一步</Button>
                </div>
                <div v-show="!planShow" style="display: flex;align-items: center; width: 180px; justify-content: space-between;">
                    <span class="blue_text" style="cursor: pointer;" @click="lastClick">上一步</span>
                    <Button type="primary" @click="saveUserRechargeInfo">确认已打款</Button>
                </div>
            </div>
            <!-- 充值金额 -->
            <div v-show="planShow" style="padding: 10px; background-color: #FFFFFF; margin-top: 20px; width: 85%;">
                <div>充值金额</div>
                <Form :model="payInfo" :label-width="80" style="margin-left: 70px;">
                    <FormItem label="充值金额">
                        <div>
                            <!-- <Input style="width: 300px;" v-model="payInfo.rechargeAmount" placeholder="请输入充值金额"></Input> -->
                            <InputNumber :precision="0"  :min="1" v-model="payInfo.rechargeAmount" style="width: 300px;"></InputNumber>
                            <div style="text-align: center; position: absolute; top: 2px;height: 30px; width: 25px; left: 273px; background-color: #FFFFFF;">元</div>
                        </div>
                    </FormItem>
                </Form>
            </div>
            <!-- 付款信息 -->
            <div v-show="planShow" style="padding: 10px; background-color: #FFFFFF; margin-top: 20px; width: 85%;">
                <div>付款信息</div>
                <Form :model="payInfo" :label-width="80" style="margin-left: 70px;">
                    <div style="margin-left: 90px; font-size: 10px;">为方便平台财务确认收款信息,请填写您用于打款的账号</div>
                    <FormItem label="付款人">
                        <div style="display: flex;">
                            <Input style="width: 300px;" v-model="payInfo.paymentAccountName" placeholder="请输入付款人账户名"></Input>
                            <div style="margin-left: 10px;">示例：张三</div>
                        </div>
                    </FormItem>
                    <FormItem label="开户银行">
                        <div style="display: flex;">
                            <Input style="width: 300px;" v-model="payInfo.bankName" placeholder="请输入开户银行"></Input>
                            <div style="margin-left: 10px;">示例：工商银行</div>
                        </div>
                    </FormItem>
                    <FormItem label="银行账号">
                        <div style="display: flex;">
                            <Input style="width: 300px;" v-model="payInfo.bankAccount" placeholder="请输入银行账号信息"></Input>
                            <div style="margin-left: 10px;">示例：621220000000000000</div>
                        </div>
                    </FormItem>
                </Form>
            </div>

            <div v-show="!planShow" style="width: 85%; height: 500px; background-color: #FFFFFF; margin-top: 20px; display: flex; justify-content: center; align-items: center;">
                <div style="display: flex; flex-direction: column; align-items: center; width: 200px;">
                    <div style="color: #FE7704; font-size: 30px;" class="icon iconfont icon-shoukuanrenguanli"></div>
                    <div style="width: 200px; height: 150px; border: 1px solid #FE7704;">
                        <div style="width: 100%;height: 30px; line-height: 30px; text-align: center; background-color: #FFF3E8;">{{payInfo.paymentAccountName}}</div>
                        <div style="margin-top: 20px; display: flex; align-items: center; justify-content: center;"><span style="font-size: 30px; margin: 0 10px;"
                                                                                                                          class="icon iconfont icon-yinxingqia"></span><span>{{payInfo.bankName}}</span></div>
                        <div style="text-align: center; margin-top: 10px;">{{payInfo.bankAccount}}</div>
                    </div>
                </div>
                <div style="display: flex;flex-direction: column;align-items: center; margin: 0 100px;">
                    <div>转账<span style="color:#FE7704 ;">{{payInfo.rechargeAmount}}</span>元</div>
                    <div style="width: 200px;border: 1px solid #DBDDE1;"></div>
                    <div style="width: 10px; border: 1px solid #DBDDE1; transform: rotate(45deg); position: relative;left: 94px;top: -6px;"></div>
                </div>
                <div style="display: flex; flex-direction: column; align-items: center;">
                    <div>{{config.name}}</div>
                    <div>收款方</div>
                    <div style="width: 450px; border: 1px solid #277dd3; ">
                        <Row style="height: 35px; line-height: 35px;">
                            <Col style="border-right: 1px solid #D7E9FC;border-bottom: 1px solid #D7E9FC; background-color: #EFF6FE; padding-left: 5px;"
                                 span="6">收款人</Col>
                            <Col style="border-bottom: 1px solid #D7E9FC;border-right: 1px solid #D7E9FC; padding-left: 5px;" span="14">{{config.bank_person_name}}</Col>
                            <Col style="border-bottom: 1px solid #D7E9FC; text-align: center;color: #277dd3;" span="4">
                                <div style="cursor: pointer;" @click="copyPayee" :data-clipboard-text="config.bank_person_name" id="payee">复制</div>
                            </Col>
                        </Row>
                        <Row style="height: 35px; line-height: 35px;">
                            <Col style="border-right: 1px solid #D7E9FC;border-bottom: 1px solid #D7E9FC; background-color: #EFF6FE; padding-left: 5px;"
                                 span="6">开户行</Col>
                            <Col style="border-bottom: 1px solid #D7E9FC;border-right: 1px solid #D7E9FC; padding-left: 5px;" span="14">{{config.bank_name}}</Col>
                            <Col style="border-bottom: 1px solid #D7E9FC; text-align: center;color: #277dd3;" span="4">
                                <div style="cursor: pointer;" @click="copyBankName" :data-clipboard-text="config.bank_name" id="bankName">复制</div>
                            </Col>
                        </Row>
                        <Row style="height: 35px; line-height: 35px;">
                            <Col style="border-right: 1px solid #D7E9FC;border-bottom: 1px solid #D7E9FC; background-color: #EFF6FE; padding-left: 5px;"
                                 span="6">账号</Col>
                            <Col style="border-bottom: 1px solid #D7E9FC;border-right: 1px solid #D7E9FC; padding-left: 5px;" span="14">{{config.bank_account}}</Col>
                            <Col style="border-bottom: 1px solid #D7E9FC; text-align: center;color: #277dd3;" span="4">
                                <div style="cursor: pointer;" @click="copyBankAccount" :data-clipboard-text="config.bank_account" id="bankAccount">复制</div>
                            </Col>
                        </Row>
                        <Row style="height: 35px; line-height: 35px;">
                            <Col style="border-right: 1px solid #D7E9FC;border-bottom: 1px solid #D7E9FC; background-color: #EFF6FE; padding-left: 5px;"
                                 span="6">收款金额</Col>
                            <Col style="border-bottom: 1px solid #D7E9FC;border-right: 1px solid #D7E9FC; padding-left: 5px;" span="14">{{payInfo.rechargeAmount}}</Col>
                            <Col style="border-bottom: 1px solid #D7E9FC; text-align: center;color: #277dd3;" span="4">
                                <div style="cursor: pointer;" @click="copySum" :data-clipboard-text="payInfo.rechargeAmount" id="rechargeAmount">复制</div>
                            </Col>
                        </Row>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import{
        saveUserRechargeInfo
    } from '@/api/user';
    import Topbar from '../topbar/TopBar.vue'
    import {getConfig} from "../../api/api";
    export default {
        name: "PayInfo",
        components: {Topbar},
        data() {
            return {
                //收款方表格内容
                config: {
                },
                planShow: true, //进度
                payInfo: {
                    rechargeAmount: 0,
                    paymentAccountName: '',
                    bankName: '',
                    bankAccount: ''
                }
            }
        },
        computed: {
            ...mapGetters(['userInfo']),
            ...mapGetters(['token'])
        },
        mounted() {
            this.loadData();
        },
        watch: {
            $route: function(route) {}
        },
        methods: {
            ...mapActions([
                'handleLogOut',
            ]),
            async loadData() {
                let that = this;
                let data = {
                    token: that.token
                };
                let res = await getConfig(that, data);
                if (res.code == 1) {
                    that.config = res.data;
                }
            },
            nextClick() {
                if (this.payInfo.rechargeAmount !== '' && this.payInfo.paymentAccountName !== '' && this.payInfo.bankName !== '' && this.payInfo
                    .bankAccount !== '') {
                    this.planShow = false
                } else if (this.payInfo.rechargeAmount == '' || this.payInfo.paymentAccountName == '' || this.payInfo.bankName == '' || this
                    .payInfo.bankAccount == '') {
                    this.$Message.error('付款信息请填写完整');
                }
            },
            lastClick() {
                this.planShow = true
            },
            copyPayee() {
                let clipboard = new this.clipboard("#payee");
                let that = this
                clipboard.on('success', function() {
                    that.$Message.success('复制成功');
                    clipboard.destroy();
                });
                clipboard.on('error', function() {
                    that.$Message.error('复制失败');
                });
            },
            copyBankName() {
                let clipboard = new this.clipboard("#bankName");
                let that = this
                clipboard.on('success', function() {
                    that.$Message.success('复制成功');
                    clipboard.destroy();
                });
                clipboard.on('error', function() {
                    that.$Message.error('复制失败');
                });
            },
            copyBankAccount() {
                let clipboard = new this.clipboard("#bankAccount");
                let that = this
                clipboard.on('success', function() {
                    that.$Message.success('复制成功');
                    clipboard.destroy();
                });
                clipboard.on('error', function() {
                    that.$Message.error('复制失败');
                });
            },
            copySum() {
                let clipboard = new this.clipboard("#rechargeAmount");
                let that = this
                clipboard.on('success', function() {
                    that.$Message.success('复制成功');
                    clipboard.destroy();
                });
                clipboard.on('error', function() {
                    that.$Message.error('复制失败');
                });
            },
            saveUserRechargeInfo(){
                let that = this
                that.throttle( () => {
                    let data = {token:that.token, payInfo:that.payInfo};
                    saveUserRechargeInfo(data).then(function(res){
                        that.$router.push({
                            name: 'Finance'
                        })
                    });
                }, 2000);


            },

        }
    }
</script>

<style>
    .pay_info{
        width: 100%;
        height: 100%;
        background-color: #F5F7F9;
    }
    .blue_text {
        color: #277dd3;
    }


</style>
